import React from "react";
import { Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";

const CurrencyInput = ({
	label,
	name,
	control,
	errors,
	placeholder,
	onKeyDown,
	autoFocus = false,
	className,
	required = false, // Adicione uma prop para required
	decimalScale = 2,
	decimalSeparator = ",",
	thousandSeparator = ".",
	prefix = "R$ ",
	allowNegative = false,
	truncate = false,
	onValueChange,
	onValueBlur,
}) => {
	const handleBlur = (rhfOnBlur) => (e) => {
		rhfOnBlur(); // marca como touched no RHF
		if (onValueBlur) {
			onValueBlur(e); // executa lógica externa, como validar ou recalcular
		}
	};

	return (
		<div className={`input-box ${className}`}>
			<label className={truncate && `truncate w-48`} htmlFor={name}>
				{label}
			</label>
			<Controller
				name={name}
				control={control}
				rules={{
					required: required ? "Este campo é obrigatório" : false,
				}}
				render={({ field: { onChange, onBlur, value, ref } }) => (
					<NumericFormat
						value={value} // Valor padrão para vazio
						onValueChange={(values, sourceInfo) => {
							onChange(values.value); // Passa o valor numérico puro para o formulário
							onValueChange?.(values.value, sourceInfo);
						}}
						decimalScale={decimalScale} // Quantidade de casas decimais
						decimalSeparator={decimalSeparator} // Separador de decimais
						thousandSeparator={thousandSeparator} // Separador de milhares
						prefix={prefix} // Prefixo, exemplo: R$
						allowNegative={allowNegative} // Permitir números negativos
						fixedDecimalScale={true} // Mostra sempre as casas decimais
						id={name}
						className={errors?.[name] ? "error" : ""}
						placeholder={placeholder}
						onBlur={handleBlur(onBlur)} // usa handleBlur interno
						onKeyDown={onKeyDown}
						autoFocus={autoFocus}
					/>
				)}
			/>
			{errors?.[name] && <p className="errors">{errors[name].message}</p>}
		</div>
	);
};

export default CurrencyInput;
